function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.968 2.58057V7.0967H7.74219V2.58057C8.90348 2.58057 10.4519 2.58057 10.968 2.58057Z",
  fill: "#909CC5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.29029 7.87085H1.03223V8.12892H1.29029V7.87085Z",
  fill: "#909CC5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3223 8.12903V13.2903H7.74165C7.74165 12.7742 7.48359 12.2581 7.09649 11.871C6.70939 11.3548 6.06423 10.9677 5.41907 10.9677C4.77391 10.9677 4.12875 11.0968 3.48359 11.6129C3.09649 11.871 2.70939 12.5161 2.58036 13.2903C2.58036 13.2903 2.58036 13.2903 2.58036 13.4194H2.06423C1.9352 13.2903 1.29004 13.0323 1.29004 12.3871C1.29004 11.4839 1.29004 9.16129 1.29004 8H10.3223V8.12903Z",
  fill: "#909CC5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2907 11.8711C17.0326 12.2582 17.2907 12.484 17.2907 13.0001L16.7746 13.2904H11.6133V11.8711H17.2907Z",
  fill: "#909CC5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.8383 11.8711C22.5802 12.2582 22.5509 12.7743 22.5509 13.2904H22.3222H21.9351C21.9351 12.7743 21.806 12.2582 21.4189 11.8711H22.8383Z",
  fill: "#909CC5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3873 11.8711V13.2904H27.355C27.355 12.7743 27.0969 12.2582 26.8389 11.8711H28.3873Z",
  fill: "#909CC5"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5486 9.16129H12.7744V0H29.6776V9.16129H29.5486ZM14.0647 7.87097H28.3873V1.29032H14.0647V7.87097Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1.03223 7.87085V8.12892H1.29029V7.87085H1.03223Z",
  fill: "#2F364F"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.6129 2.06456V10.5807H29.6774V14.4517H27.0968C27.0288 14.5707 26.9563 14.683 26.8793 14.7883C26.4309 15.4587 25.6669 15.9001 24.7998 15.9001C24.6592 15.9001 24.5214 15.8885 24.3871 15.8662C24.1068 15.845 23.8583 15.7547 23.6355 15.613C23.1519 15.358 22.7621 14.9492 22.5311 14.4517H21.6774C21.1613 15.3549 20.3871 15.871 19.3548 15.871H19.0968C18.1935 15.742 17.4194 15.2259 17.0323 14.4517H11.6129H7.48387C7.35484 14.8388 7.09677 15.0968 6.83871 15.3549C6.32258 15.742 5.80645 16 5.16129 16H4.90323C4.25806 16 3.6129 15.613 3.22581 15.0968C3.16129 15.0323 3.12903 14.9355 3.09677 14.8388C3.06452 14.742 3.03226 14.6452 2.96774 14.5807H2.06452H1.93548C1.29032 14.4517 0 13.8065 0 12.3871V7.22585C0.00569085 7.1974 0.0126366 7.16091 0.0209702 7.11714L0.0209709 7.11713C0.201591 6.16834 1.03412 1.79512 3.87097 1.54843C6.45161 1.4194 10.8387 1.4194 10.9677 1.54843H11.6129V2.06456ZM22.8218 11.871C22.5154 12.2667 22.3252 12.7569 22.3022 13.2904H21.9355C21.9355 12.7742 21.8065 12.2581 21.4194 11.871H22.8218ZM7.74194 13.1613H10.3226V8.12908H1.29032V12.3871C1.29032 12.899 1.69634 13.1671 1.92861 13.3206C1.98912 13.3605 2.03785 13.3927 2.06452 13.4194H2.58065V13.2904C2.70968 12.5162 3.09677 11.871 3.48387 11.613C4.12903 11.0968 4.77419 10.9678 5.41935 10.9678C6.06452 10.9678 6.82895 11.3549 7.21605 11.871C7.60315 12.2581 7.74194 12.6452 7.74194 13.1613ZM1.03226 8.00005H1.29032V7.87102H1.03226V8.00005ZM1.41935 6.70972L10.4516 6.83876V2.70972H7.87097C7.18985 2.70972 6.43683 2.74568 5.72577 2.77963C5.08978 2.80999 4.48737 2.83876 4 2.83876C2.58065 2.83876 1.67742 5.29037 1.41935 6.70972ZM11.6129 13.1613H16.7742L16.8049 13.0388C16.8321 12.6115 16.9667 12.2133 17.182 11.871H11.6129V13.1613ZM27.3548 13.2904H28.3871V11.871H26.8387C27.0968 12.2581 27.3548 12.7742 27.3548 13.2904ZM5.2499 14.9001C5.99549 14.9001 6.5999 14.2957 6.5999 13.5501C6.5999 12.8045 5.99549 12.2001 5.2499 12.2001C4.50432 12.2001 3.8999 12.8045 3.8999 13.5501C3.8999 14.2957 4.50432 14.9001 5.2499 14.9001ZM20.7 13.5501C20.7 14.2957 20.0956 14.9001 19.35 14.9001C18.6044 14.9001 18 14.2957 18 13.5501C18 12.8045 18.6044 12.2001 19.35 12.2001C20.0956 12.2001 20.7 12.8045 20.7 13.5501ZM24.85 14.9001C25.5956 14.9001 26.2 14.2957 26.2 13.5501C26.2 12.8045 25.5956 12.2001 24.85 12.2001C24.1044 12.2001 23.5 12.8045 23.5 13.5501C23.5 14.2957 24.1044 14.9001 24.85 14.9001Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1.29029 7.87085H1.03223V8.12892H1.29029V7.87085Z"
});

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.c316016a.svg";
export { ForwardRef as ReactComponent };